export const BB_LOGO_SIZE = 132;
